export const formatDecimal = number => {
  if (typeof number !== "number") return "";

  return Number.isInteger(number) ? number : number?.toFixed(2);
};


export const format1Decimal = number => {
  if (typeof number !== "number") return "";

  return Number.isInteger(number) ? number : number?.toFixed(1);
};